import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-evo-admin-school-teachers-edit-groups',
  templateUrl: './evo-admin-school-teachers-edit-groups.component.html',
  styleUrls: ['./evo-admin-school-teachers-edit-groups.component.css']
})
export class EvoAdminSchoolTeachersEditGroupsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
